<template>
    <div>
        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            aria-hidden="true" ref="modal">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">{{ title }}</h5>
                    </div>
                    <div class="modal-body">
                        <div style="display: flex; flex-direction: column; width: 100%;height: 50%;">
                            <UploadImage @save="saveImage" :url="image" />
                            <label for="arabicName">الاسم العربي:</label>
                            <input id="arabicName" type="input" style="margin-right: 10px;" v-model="categoryNameAr" />
                            <label for="englishName">الاسم الانجليزي:</label>
                            <input id="englishName" type="input" style="margin-right: 10px;" v-model="categoryNameEn" />
                            <CommonSelect
                                v-model="selectedCategory"
                                :options="options"
                                label="القسم الأب"
                                id="category"
                                hasDefaultOption
                                defaultOptionText="اختر القسم"
                            />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" 
                        @click="closeModal">إلغاء</button>
                        <button type="button" class="btn btn-primary" @click="save">حفظ</button>
                    </div>
                </div>
            </div>
        </div>
        <ErrorDialog :msg="errorMessage" />
    </div>
</template>
  
<script setup>
import { onMounted, nextTick, ref, watch } from "vue";
import { ApiClient, CategoryControllerApi, CategoryEntity } from "../api/index.js"
import UploadImage from "./UploadImage.vue";
import { uploadFileToFirebase,saveToFirebase} from "../firebase/Utils.js";
import ErrorDialog from './ErrorDialog.vue';
import CommonSelect from './CommonSelect.vue';

// const props = defineProps(['categories']);
const props = defineProps(["category"]);
const emit = defineEmits(["save"]);

const apiClient = new ApiClient();

const categoryApi = new CategoryControllerApi(apiClient);

const options = ref([]);

const title = ref("قسم جديد");
const catId = ref(null);
const categoryNameAr = ref('');
const categoryNameEn = ref('');
const selectedCategory = ref(null);
const image = ref(null);
const errorMessage = ref('');

watch(() => selectedCategory.value, (newValue, oldValue) => {
    selectedCategory.value = newValue;//todo: fix this fucking bug
});


watch(
    () => props.category,
    (newCategory) => {
        if (newCategory) {
            title.value = "تعديل قسم";
            catId.value=newCategory.id;
            categoryNameAr.value = newCategory.nameAr;
            categoryNameEn.value = newCategory.nameEn;
            selectedCategory.value = newCategory.parent.id;
            image.value=newCategory.imgCover;            
        } else {
            title.value="قسم جديد";
            catId.value=null;
            categoryNameAr.value = "";
            categoryNameEn.value = "";
            selectedCategory.value = null;
            image.value=null;
        }
    }
);


onMounted(() => {
    nextTick(() => {
        // Initialize Bootstrap modals
        const modalEls = document.querySelectorAll('.modal');
        modalEls.forEach((el) => {
            new window.bootstrap.Modal(el);
        });
        // console.log(props.categories);
        // options.push(...props.categories);

        // //get categories
        categoryApi.getCategories(localStorage.getItem('token'),{ isChild: false }, (error, data, response) => {
            if (error) {
                console.error(error);
                return;
            }
            options.value = data.content.filter(category => category.id !== 'personal_pages');
        });
    });
});

function languageChanged(lang) {
    selectedLanguage.value = lang.value;
}

async function saveImage(imageData) {
    const randomName = Math.random().toString(36).substring(2, 15);
    image.value = await uploadFileToFirebase(imageData, "categories/covers", `${randomName}.jpg`);
}


function save() {
    try {
        errorMessage.value = ''; // Reset error message
        var category = new CategoryEntity();

        // const categoryIdValue = (selectedCategory.value||'').trim();
        // const langValue = (selectedLanguage.value || '').trim();
        const categoryAr = categoryNameAr.value;// (categoryNameAr.value).trim();
        const categoryEn = categoryNameEn.value;// (categoryNameAr.value).trim();

        category.nameAr = categoryAr || (() => { throw new Error('الاسم العربي لا يمكن أن يكون فارغ') })();
        category.nameEn = categoryEn || (() => { throw new Error('الاسم الانجليزي لا يمكن أن يكون فارغ') })();
        category.parent = { id: selectedCategory.value!=null?selectedCategory.value:(()=>{throw new Error('يجب إختيار قسم')})() };
        category.id=catId.value;
        category.isMediaCategory = false;
        category.imgCover=image.value;

        
        categoryApi.addCategory(category, localStorage.getItem("token"), (error, data, response) => {
            if (error == null) {
                emit("save", category);
                location.reload();
            } else {
                errorMessage.value = error.message || 'An error occurred while saving the category.';
            }
        });
    } catch (error) {
        errorMessage.value = error.message || 'An unexpected error occurred.';
    }

}

function closeModal() {
    document.location.reload();
    }
</script>

<style scoped>
.modal-content {
  border-radius: 0.5rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.modal-header {
  background-color: var(--primary-color);
  color: var(--text-light);
  padding: 1rem 1.5rem;
}

.modal-title {
  font-weight: bold;
}

.modal-body {
  background-color: var(--background-light);
  padding: 1.5rem;
}

.modal-footer {
  background-color: var(--background-light);
  border-top: 1px solid var(--border-color);
  padding: 1rem 1.5rem;
}

.btn {
  border-radius: 0.25rem;
  padding: 0.75rem 1.5rem;
  font-weight: bold;
  transition: all 0.2s ease-in-out;
}

.btn-primary {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: var(--text-light);
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--primary-light);
  border-color: var(--primary-light);
}

.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
  color: var(--text-light);
}

.btn-secondary:hover {
  background-color: #5a6268;
  border-color: #545b62;
}

.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

input[type="input"], select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--border-color);
  border-radius: 0.25rem;
  transition: border-color 0.2s ease-in-out;
  margin-bottom: 1rem;
}

input[type="input"]:focus, select:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(89, 3, 5, 0.25);
}

label {
  display: block;
  margin-bottom: 0.5rem;
  color: var(--primary-dark);
  font-weight: bold;
}
</style>
